// import web from '../src/images/web.jpg';
// import app from '../src/images/app.jpg';
// import digi from '../src/images/digi.jpg';
// import mark from '../src/images/mark.jpg';
// import soft from '../src/images/soft.jpg';
// import ando from "../src/images/ando.jpg";
import web from '../src/images/banner1.jpg'
import ban from '../src/images/banner3.jpg'


const Sdata = [

    {	
        imgsrc: web,
        title: "Web Development",
    },
    {	
        imgsrc: ban,
        title: "App Development",
    },	
    {	
        imgsrc: web,
        title: "Software Development",
    },
    {	
        imgsrc: ban,
        title: "Digital Marketing",
    },	
    {	
        imgsrc: web,
        title: "Android Development",
    },
    {	
        imgsrc: ban,
        title: "Marketing",
    },
   
    ];
    
    export default Sdata;